import { createSeamlessAudioLoop } from './audioLoop.js';

const notes = (pattern) => pattern.split(' ').map((note) => note === '.' ? null : Number(note));

const MENU_MUSIC_TRACK = {
  name:'Habitación de juguetes',bpm:92,root:48,wave:'triangle',bassWave:'sine',minor:false,
  lead:notes('0 . 4 . 7 . 11 . 7 . 4 . 2 . 4 .'),
  bass:notes('0 . . . 5 . . . 3 . . . 7 . . .'),
  chords:[0,5,3,7],kick:'x.......x.......',snare:'....x.......x...',hats:'..x...x...x...x.',
};

const LEVEL_MUSIC_TRACKS = [
  {
    name:'Carrera de alfombra',bpm:126,root:48,wave:'square',bassWave:'sawtooth',minor:true,
    lead:notes('0 . 3 7 . 10 7 . 0 . 3 12 10 7 3 .'),bass:notes('0 . 0 . 8 . 7 . 0 . 0 3 5 . 7 .'),
    chords:[0,8,3,7],kick:'x...x...x..x..x.',snare:'....x.......x...',hats:'.x.x.x.x.x.x.x.x',
  },
  {
    name:'Turbo de cartón',bpm:138,root:50,wave:'sawtooth',bassWave:'square',minor:false,
    lead:notes('0 4 7 . 12 7 4 . 2 6 9 . 14 9 6 .'),bass:notes('0 . 0 7 9 . 9 . 2 . 2 9 7 . 7 .'),
    chords:[0,9,2,7],kick:'x..x..x.x..x..x.',snare:'....x.......x...',hats:'xxxxxxxxxxxxxxxx',
  },
  {
    name:'Caos en el living',bpm:132,root:45,wave:'triangle',bassWave:'sawtooth',minor:true,
    lead:notes('0 . 7 5 3 . 10 7 0 . 12 10 7 5 3 .'),bass:notes('0 . . 0 8 . . 8 5 . . 5 10 . 7 .'),
    chords:[0,8,5,10],kick:'x...x.x.x...x.x.',snare:'....x.......x...',hats:'..x.x.x...x.x.x.',
  },
  {
    name:'Jardín supersónico',bpm:146,root:52,wave:'square',bassWave:'triangle',minor:false,
    lead:notes('0 2 4 7 9 7 4 2 0 4 7 11 14 11 7 4'),bass:notes('0 . 0 . 5 . 5 . 9 . 9 . 7 . 7 .'),
    chords:[0,5,9,7],kick:'x.x...x.x.x...x.',snare:'....x.......x...',hats:'.xxxxxxxxxxxxxxx',
  },
  {
    name:'Fuga bajo la mesa',bpm:120,root:43,wave:'sine',bassWave:'square',minor:true,
    lead:notes('0 . 3 . 7 8 7 . 5 . 3 . 10 8 7 .'),bass:notes('0 . . . 5 . 5 . 8 . . . 10 . 7 .'),
    chords:[0,5,8,10],kick:'x.......x...x...',snare:'....x.......x...',hats:'..x...x...x...x.',
  },
  {
    name:'Patrulla de bloques',bpm:150,root:47,wave:'sawtooth',bassWave:'square',minor:true,
    lead:notes('0 0 3 5 7 7 10 12 10 7 5 3 0 3 7 10'),bass:notes('0 . 0 . 3 . 3 . 8 . 8 . 10 . 10 .'),
    chords:[0,3,8,10],kick:'x..x.x..x..x.x..',snare:'....x.......x...',hats:'xxxxxxxxxxxxxxxx',
  },
  {
    name:'Rebote de almohadas',bpm:112,root:53,wave:'triangle',bassWave:'sine',minor:false,
    lead:notes('0 . 4 7 9 . 7 4 2 . 6 9 11 . 9 6'),bass:notes('0 . . . 7 . . . 2 . . . 9 . 7 .'),
    chords:[0,7,2,9],kick:'x.....x.x.....x.',snare:'....x.......x...',hats:'..x...x...x...x.',
  },
  {
    name:'Derrape de plastilina',bpm:142,root:46,wave:'square',bassWave:'sawtooth',minor:true,
    lead:notes('0 3 . 5 7 10 . 12 7 5 . 3 0 3 5 7'),bass:notes('0 . 0 . 10 . 10 . 5 . 5 . 7 . 7 .'),
    chords:[0,10,5,7],kick:'x.x.x...x.x.x...',snare:'....x.......x...',hats:'.x.xxxxxxxxxxxxx',
  },
  {
    name:'Ataque de los juguetes',bpm:154,root:49,wave:'sawtooth',bassWave:'triangle',minor:true,
    lead:notes('0 7 3 10 7 12 10 7 0 7 3 10 12 15 12 10'),bass:notes('0 . 0 0 6 . 6 6 8 . 8 8 10 . 7 7'),
    chords:[0,6,8,10],kick:'x.xx..x.x.xx..x.',snare:'....x.......x...',hats:'xxxxxxxxxxxxxxxx',
  },
  {
    name:'Última vuelta',bpm:136,root:51,wave:'triangle',bassWave:'square',minor:false,
    lead:notes('0 . 4 7 12 11 7 4 2 . 6 9 14 12 9 6'),bass:notes('0 . 0 . 8 . 8 . 2 . 2 . 7 . 7 .'),
    chords:[0,8,2,7],kick:'x...x..xx...x..x',snare:'....x.......x...',hats:'.x.x.x.xxxxxxxxx',
  },
];

const RECORDED_MUSIC_FILES = Object.freeze([
  'audiodollar-big-rock-production-rock-508503.mp3',
  'bombinsound-energetic-upbeat-future-bass-version-1-537886.mp3',
  'bombinsound-future-bass-music-say-my-name-570522.mp3',
  'bombinsound-motivation-motivation-music-feel-good-566563.mp3',
  'bombinsound-summer-with-you-564682.mp3',
  'bombinsound-upbeat-rock-514146.mp3',
  'bombinsound-upbeat-rock-version-3-544113.mp3',
  'bombinsound-vlog-future-bass-547231.mp3',
  'oceanframemusic-music-rock-460150.mp3',
  'prettyjohn1-future-bass-523169.mp3',
]);

export const MUSIC_TRACK_COUNT = RECORDED_MUSIC_FILES.length;

const recordedMusicUrl = (fileName) => new URL(
  `${import.meta.env.BASE_URL}audio/music/${fileName}`,
  document.baseURI,
).href;

const midiFrequency = (note) => 440 * 2 ** ((note - 69) / 12);
const AUDIO_WAVES=new Set(['sine','triangle','sawtooth','square']);
const AUDIO_FILTERS=new Set(['lowpass','bandpass','highpass']);
const UI_SOUND_VOLUME_MULTIPLIER=1.8;
const audioNumber=(value,fallback,min,max)=>{
  const number=Number(value);
  return Number.isFinite(number)?Math.max(min,Math.min(max,number)):fallback;
};

const setAudioParam=(parameter,value,time,constant=.045)=>{
  if(!parameter)return;
  if(typeof parameter.setTargetAtTime==='function')parameter.setTargetAtTime(value,time,constant);
  else parameter.value=value;
};

class SpatialVehicleEmitter {
  constructor(audio,vehicle){
    this.audio=audio;
    this.vehicle=vehicle;
    this.context=audio.context;
    this.disposed=false;
    this.panner=this.context.createPanner();
    this.panner.panningModel='HRTF';
    this.panner.distanceModel='inverse';
    this.panner.refDistance=2.2;
    this.panner.maxDistance=30;
    this.panner.rolloffFactor=1.25;
    this.panner.coneInnerAngle=360;
    this.panner.coneOuterAngle=360;
    this.panner.connect(audio.effectsGain);

    this.engineOsc=this.context.createOscillator();
    this.engineOsc.type='sawtooth';
    this.engineFilter=this.context.createBiquadFilter();
    this.engineFilter.type='lowpass';
    this.engineGain=this.context.createGain();
    this.engineGain.gain.value=0;
    this.engineOsc.connect(this.engineFilter);
    this.engineFilter.connect(this.engineGain);
    this.engineGain.connect(this.panner);
    this.engineSampleGain=this.context.createGain();
    this.engineSampleGain.gain.value=0;
    this.engineSampleGain.connect(this.panner);
    this.engineSampleSource=null;
    this.engineSampleTargetUrl='';
    this.engineSampleLoadedUrl='';
    this.engineSampleRequest=0;

    this.noiseSource=this.context.createBufferSource();
    this.noiseSource.buffer=audio.noiseBuffer;
    this.noiseSource.loop=true;
    this.engineNoiseFilter=this.context.createBiquadFilter();
    this.engineNoiseFilter.type='lowpass';
    this.engineNoiseGain=this.context.createGain();
    this.engineNoiseGain.gain.value=0;
    this.skidFilter=this.context.createBiquadFilter();
    this.skidFilter.type='bandpass';
    this.skidFilter.Q.value=1.1;
    this.skidGain=this.context.createGain();
    this.skidGain.gain.value=0;
    this.boostFilter=this.context.createBiquadFilter();
    this.boostFilter.type='bandpass';
    this.boostFilter.Q.value=.72;
    this.boostGain=this.context.createGain();
    this.boostGain.gain.value=0;
    this.noiseSource.connect(this.engineNoiseFilter);
    this.engineNoiseFilter.connect(this.engineNoiseGain);
    this.engineNoiseGain.connect(this.panner);
    this.noiseSource.connect(this.skidFilter);
    this.skidFilter.connect(this.skidGain);
    this.skidGain.connect(this.panner);
    this.noiseSource.connect(this.boostFilter);
    this.boostFilter.connect(this.boostGain);
    this.boostGain.connect(this.panner);

    this.boostOsc=this.context.createOscillator();
    this.boostOsc.type='sawtooth';
    this.boostGainTone=this.context.createGain();
    this.boostGainTone.gain.value=0;
    this.boostOsc.connect(this.boostGainTone);
    this.boostGainTone.connect(this.panner);
    this.nitroSampleGain=this.context.createGain();
    this.nitroSampleGain.gain.value=0;
    this.nitroSampleGain.connect(this.panner);
    this.nitroSampleSource=null;
    this.nitroSampleTargetUrl='';
    this.nitroSampleLoadedUrl='';
    this.nitroSampleRequest=0;

    this.engineOsc.start();
    this.noiseSource.start();
    this.boostOsc.start();
  }

  stopLoopSample(kind){
    const sourceKey=`${kind}SampleSource`;
    const loadedKey=`${kind}SampleLoadedUrl`;
    const source=this[sourceKey];
    this[sourceKey]=null;
    this[loadedKey]='';
    if(!source)return;
    try{source.stop();}catch{}
    try{source.disconnect();}catch{}
  }

  setLoopSample(kind,value,settings={}){
    const targetKey=`${kind}SampleTargetUrl`;
    const requestKey=`${kind}SampleRequest`;
    const sourceKey=`${kind}SampleSource`;
    const loadedKey=`${kind}SampleLoadedUrl`;
    const gain=this[`${kind}SampleGain`];
    const url=String(value||'').trim();
    if(url===this[targetKey])return;
    this[targetKey]=url;
    const request=++this[requestKey];
    gain.gain.setTargetAtTime(0,this.context.currentTime,.025);
    this.stopLoopSample(kind);
    if(!url)return;
    const record=this.audio.prepareOneShotSample(url);
    record?.promise?.then((decodedBuffer)=>{
      if(
        !decodedBuffer
        ||this.disposed
        ||request!==this[requestKey]
        ||url!==this[targetKey]
      )return;
      const source=this.context.createBufferSource();
      source.buffer=createSeamlessAudioLoop(this.context,decodedBuffer,settings);
      source.loop=true;
      source.connect(gain);
      source.addEventListener('ended',()=>{
        if(this[sourceKey]===source){
          this[sourceKey]=null;
          this[loadedKey]='';
        }
        source.disconnect();
      },{once:true});
      this[sourceKey]=source;
      this[loadedKey]=url;
      source.start();
    });
  }

  update(vehicle){
    if(this.disposed)return;
    this.vehicle=vehicle;
    const now=this.context.currentTime;
    const position=vehicle.car.position;
    setAudioParam(this.panner.positionX,position.x,now,.025);
    setAudioParam(this.panner.positionY,position.y,now,.025);
    setAudioParam(this.panner.positionZ,position.z,now,.025);
    if(!this.panner.positionX&&typeof this.panner.setPosition==='function'){
      this.panner.setPosition(position.x,position.y,position.z);
    }

    const active=!vehicle.disabled&&vehicle.car.visible!==false;
    const speed=active?Math.abs(Number(vehicle.forwardSpeed)||0):0;
    const engine=vehicle.car.userData.engineSound||{};
    const nitro=vehicle.car.userData.nitroEffect||{};
    this.setLoopSample('engine',engine.mode==='mp3'?engine.assetUrl:'',engine);
    this.setLoopSample('nitro',nitro.soundMode==='mp3'?nitro.soundUrl:'',nitro);
    const engineSampleReady=Boolean(
      this.engineSampleSource
      &&this.engineSampleLoadedUrl===this.engineSampleTargetUrl
    );
    const nitroSampleReady=Boolean(
      this.nitroSampleSource
      &&this.nitroSampleLoadedUrl===this.nitroSampleTargetUrl
    );
    const pulse=audioNumber(engine.pulse,6,.1,30);
    const pulseAmount=.94+Math.sin(now*pulse)*.06;
    this.engineOsc.type=AUDIO_WAVES.has(engine.wave)?engine.wave:'sawtooth';
    this.engineOsc.frequency.setTargetAtTime(
      (
        audioNumber(engine.baseTone,65,25,280)
        +speed*audioNumber(engine.speedPitch,7,1,18)
        +(vehicle.boosting?audioNumber(engine.boostPitch,45,0,160):0)
      )*pulseAmount,
      now,
      .055,
    );
    this.engineFilter.type=AUDIO_FILTERS.has(engine.filterType)?engine.filterType:'lowpass';
    this.engineFilter.frequency.setTargetAtTime(
      audioNumber(engine.filter,430,70,12000)+speed*12,
      now,
      .08,
    );
    this.engineFilter.Q.setTargetAtTime(audioNumber(engine.resonance,1,0,18),now,.08);
    const engineVolume=audioNumber(engine.volume,.037,0,.18);
    this.engineGain.gain.setTargetAtTime(
      active&&!engineSampleReady?(engineVolume*.23+Math.min(speed/900,engineVolume*.5)):0,
      now,
      .09,
    );
    this.engineNoiseFilter.type=this.engineFilter.type;
    this.engineNoiseFilter.frequency.setTargetAtTime(
      audioNumber(engine.filter,430,70,12000)*.82+speed*10,
      now,
      .09,
    );
    this.engineNoiseGain.gain.setTargetAtTime(
      active&&!engineSampleReady?audioNumber(engine.noiseGain,.005,0,.08)*.68:0,
      now,
      .1,
    );
    if(this.engineSampleGain){
      const playbackRate=Math.max(.35,Math.min(3,
        audioNumber(engine.sampleIdleRate,1,.5,1.5)
        +speed*audioNumber(engine.sampleSpeedRate,.04,0,.12)
        +(vehicle.boosting?audioNumber(engine.sampleBoostRate,.35,0,1.2):0),
      ));
      this.engineSampleSource?.playbackRate.setTargetAtTime(playbackRate,now,.06);
      const sampleVolume=audioNumber(engine.sampleVolume,.28,.02,.8);
      const speedVolume=.72+Math.min(1,speed/24)*.28;
      this.engineSampleGain.gain.setTargetAtTime(
        active&&engineSampleReady?sampleVolume*speedVolume*.72:0,
        now,
        .09,
      );
    }

    const skid=active?Math.max(0,Math.min(1,Number(vehicle.skidAmount)||0)):0;
    this.skidFilter.frequency.setTargetAtTime(760+speed*30,now,.05);
    this.skidGain.gain.setTargetAtTime(skid*.065,now,.04);

    const boostActive=Boolean(active&&vehicle.boosting);
    const profile=this.audio.nitroProfile(nitro);
    const flutter=boostActive
      ?(nitro.style==='confetti'?.78+Math.sin(now*profile.pulse)*.22:.94+Math.sin(now*profile.pulse)*.06)
      :0;
    this.boostFilter.type=profile.filterType;
    this.boostFilter.frequency.setTargetAtTime(profile.filter+speed*18,now,.045);
    this.boostGain.gain.setTargetAtTime(
      boostActive&&!nitroSampleReady?profile.noiseGain*flutter*.72:0,
      now,
      boostActive?.05:.12,
    );
    this.boostOsc.type=profile.wave;
    this.boostOsc.frequency.setTargetAtTime(profile.tone+speed*2.5,now,.05);
    this.boostGainTone.gain.setTargetAtTime(
      boostActive&&!nitroSampleReady?profile.toneGain*flutter*.72:0,
      now,
      boostActive?.05:.12,
    );
    this.nitroSampleSource?.playbackRate.setTargetAtTime(
      audioNumber(nitro.soundSampleRate,1,.5,2),
      now,
      .05,
    );
    this.nitroSampleGain.gain.setTargetAtTime(
      boostActive&&nitroSampleReady
        ?audioNumber(nitro.soundSampleVolume,.5,.02,1)*.72
        :0,
      now,
      boostActive?.05:.12,
    );
  }

  dispose(){
    if(this.disposed)return;
    this.disposed=true;
    this.engineSampleRequest+=1;
    this.nitroSampleRequest+=1;
    const now=this.context.currentTime;
    [
      this.engineGain,this.engineSampleGain,this.engineNoiseGain,this.skidGain,
      this.boostGain,this.boostGainTone,this.nitroSampleGain,
    ]
      .forEach((node)=>node.gain.setTargetAtTime(0,now,.012));
    this.stopLoopSample('engine');
    this.stopLoopSample('nitro');
    [this.engineOsc,this.noiseSource,this.boostOsc].forEach((source)=>{
      try{source.stop(now+.05);}catch{}
    });
    window.setTimeout(()=>{
      [
        this.engineOsc,this.engineFilter,this.engineGain,this.engineSampleGain,this.noiseSource,
        this.engineNoiseFilter,this.engineNoiseGain,this.skidFilter,this.skidGain,
        this.boostFilter,this.boostGain,this.boostOsc,this.boostGainTone,
        this.nitroSampleGain,this.panner,
      ].forEach((node)=>{try{node.disconnect();}catch{}});
    },90);
  }
}

export class GameAudio {
  constructor() {
    this.context = null;
    this.master = null;
    this.effectsGain = null;
    this.masterVolume = 1;
    this.musicVolume = 1;
    this.effectsVolume = 1;
    this.engineOsc = null;
    this.engineGain = null;
    this.engineFilter = null;
    this.engineNoiseSource = null;
    this.engineNoiseGain = null;
    this.engineNoiseFilter = null;
    this.engineSampleSource = null;
    this.engineSampleGain = null;
    this.engineSampleFilter = null;
    this.engineSampleTargetUrl = '';
    this.engineSampleLoadedUrl = '';
    this.engineSampleRequest = 0;
    this.engineSampleBuffers = new Map();
    this.oneShotSampleBuffers = new Map();
    this.nitroSampleSource = null;
    this.nitroSampleGain = null;
    this.nitroSampleTargetUrl = '';
    this.nitroSampleLoadedUrl = '';
    this.nitroSampleRequest = 0;
    this.noiseBuffer = null;
    this.skidSource = null;
    this.skidGain = null;
    this.skidFilter = null;
    this.skidOsc = null;
    this.skidOscGain = null;
    this.boostSource = null;
    this.boostFilter = null;
    this.boostGain = null;
    this.boostOsc = null;
    this.boostOscGain = null;
    this.boostWasActive = false;
    this.boostDesign = null;
    this.musicGain = null;
    this.musicElement = null;
    this.musicElementSource = null;
    this.musicMode = 'menu';
    this.musicTrack = null;
    this.musicStep = 0;
    this.nextMusicTime = 0;
    this.lastLevelTrack = -1;
    this.currentRecordedMusicIndex = -1;
    this.musicPaused = false;
    this.muted = false;
    this.spatialVehicleEmitters = new Map();
    this.maxSpatialVehicles = 5;
  }

  ensure() {
    if (this.context) {
      if (this.context.state === 'suspended') {
        this.context.resume()
          .then(() => this.tryPlayRecordedMusic())
          .catch(() => {});
      } else {
        this.tryPlayRecordedMusic();
      }
      return;
    }
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    this.context = new AudioContext();
    this.master = this.context.createGain();
    this.master.gain.value = this.muted ? 0 : .24*this.masterVolume;
    this.master.connect(this.context.destination);
    this.effectsGain=this.context.createGain();
    this.effectsGain.gain.value=this.effectsVolume;
    this.effectsGain.connect(this.master);
    this.engineOsc = this.context.createOscillator();
    this.engineOsc.type = 'sawtooth';
    this.engineGain = this.context.createGain();
    this.engineGain.gain.value = 0;
    this.engineFilter = this.context.createBiquadFilter();
    this.engineFilter.type = 'lowpass'; this.engineFilter.frequency.value = 430;
    this.engineOsc.connect(this.engineFilter);this.engineFilter.connect(this.engineGain);this.engineGain.connect(this.effectsGain);this.engineOsc.start();

    this.noiseBuffer = this.context.createBuffer(1,Math.ceil(this.context.sampleRate),this.context.sampleRate);
    const noiseData=this.noiseBuffer.getChannelData(0);
    for(let index=0;index<noiseData.length;index+=1)noiseData[index]=Math.random()*2-1;

    this.engineNoiseSource=this.context.createBufferSource();
    this.engineNoiseSource.buffer=this.noiseBuffer;this.engineNoiseSource.loop=true;
    this.engineNoiseFilter=this.context.createBiquadFilter();this.engineNoiseFilter.type='lowpass';this.engineNoiseFilter.frequency.value=620;
    this.engineNoiseGain=this.context.createGain();this.engineNoiseGain.gain.value=0;
    this.engineNoiseSource.connect(this.engineNoiseFilter);this.engineNoiseFilter.connect(this.engineNoiseGain);this.engineNoiseGain.connect(this.effectsGain);this.engineNoiseSource.start();

    this.engineSampleFilter=this.context.createBiquadFilter();
    this.engineSampleFilter.type='lowpass';this.engineSampleFilter.frequency.value=12000;
    this.engineSampleGain=this.context.createGain();this.engineSampleGain.gain.value=0;
    this.engineSampleFilter.connect(this.engineSampleGain);this.engineSampleGain.connect(this.effectsGain);

    this.skidSource=this.context.createBufferSource();
    this.skidSource.buffer=this.noiseBuffer;this.skidSource.loop=true;
    this.skidFilter=this.context.createBiquadFilter();
    this.skidFilter.type='bandpass';this.skidFilter.frequency.value=1050;this.skidFilter.Q.value=1.1;
    this.skidGain=this.context.createGain();this.skidGain.gain.value=0;
    this.skidSource.connect(this.skidFilter);this.skidFilter.connect(this.skidGain);this.skidGain.connect(this.effectsGain);this.skidSource.start();

    this.skidOsc=this.context.createOscillator();this.skidOsc.type='triangle';this.skidOsc.frequency.value=520;
    this.skidOscGain=this.context.createGain();this.skidOscGain.gain.value=0;
    this.skidOsc.connect(this.skidOscGain);this.skidOscGain.connect(this.effectsGain);this.skidOsc.start();

    this.boostSource=this.context.createBufferSource();
    this.boostSource.buffer=this.noiseBuffer;this.boostSource.loop=true;
    this.boostFilter=this.context.createBiquadFilter();this.boostFilter.type='bandpass';this.boostFilter.frequency.value=1100;this.boostFilter.Q.value=.72;
    this.boostGain=this.context.createGain();this.boostGain.gain.value=0;
    this.boostSource.connect(this.boostFilter);this.boostFilter.connect(this.boostGain);this.boostGain.connect(this.effectsGain);this.boostSource.start();

    this.boostOsc=this.context.createOscillator();this.boostOsc.type='sawtooth';this.boostOsc.frequency.value=165;
    this.boostOscGain=this.context.createGain();this.boostOscGain.gain.value=0;
    this.boostOsc.connect(this.boostOscGain);this.boostOscGain.connect(this.effectsGain);this.boostOsc.start();

    this.nitroSampleGain=this.context.createGain();
    this.nitroSampleGain.gain.value=0;
    this.nitroSampleGain.connect(this.effectsGain);

    this.musicGain=this.context.createGain();this.musicGain.gain.value=.18;
    this.musicGain.connect(this.master);
    this.musicElement=new Audio();
    this.musicElement.preload='auto';
    this.musicElementSource=this.context.createMediaElementSource(this.musicElement);
    this.musicElementSource.connect(this.musicGain);
    this.musicElement.addEventListener('ended',()=>{
      if(!this.musicPaused)this.playRandomRecordedMusic(this.musicMode);
    });
    if(this.currentRecordedMusicIndex>=0)this.startRecordedMusic(this.currentRecordedMusicIndex);
    this.updateMusicGain();
    this.nextMusicTime=this.context.currentTime+.06;
  }

  setMuted(value) {
    this.muted = value;
    if (this.master) this.master.gain.setTargetAtTime(value ? 0 : .24*this.masterVolume, this.context.currentTime, .03);
  }

  setVolumes({master=this.masterVolume,music=this.musicVolume,effects=this.effectsVolume}={}) {
    this.masterVolume=audioNumber(master,this.masterVolume,0,1);
    this.musicVolume=audioNumber(music,this.musicVolume,0,1);
    this.effectsVolume=audioNumber(effects,this.effectsVolume,0,1);
    if(!this.context)return;
    this.master?.gain.setTargetAtTime(this.muted?0:.24*this.masterVolume,this.context.currentTime,.03);
    this.effectsGain?.gain.setTargetAtTime(this.effectsVolume,this.context.currentTime,.05);
    this.updateMusicGain();
  }

  pickRandomRecordedMusic(){
    if(RECORDED_MUSIC_FILES.length<=1)return 0;
    let index=Math.floor(Math.random()*RECORDED_MUSIC_FILES.length);
    if(index===this.currentRecordedMusicIndex){
      index=(index+1+Math.floor(Math.random()*(RECORDED_MUSIC_FILES.length-1)))%RECORDED_MUSIC_FILES.length;
    }
    return index;
  }

  tryPlayRecordedMusic(){
    if(!this.musicElement||this.currentRecordedMusicIndex<0)return;
    const playback=this.musicElement.play();
    if(playback?.catch)playback.catch(()=>{});
  }

  startRecordedMusic(index){
    if(!this.musicElement)return;
    this.musicElement.pause();
    this.musicElement.src=recordedMusicUrl(RECORDED_MUSIC_FILES[index]);
    this.musicElement.currentTime=0;
    this.musicElement.load();
    this.tryPlayRecordedMusic();
  }

  playRandomRecordedMusic(mode){
    this.musicMode=mode;
    this.currentRecordedMusicIndex=this.pickRandomRecordedMusic();
    this.startRecordedMusic(this.currentRecordedMusicIndex);
    this.updateMusicGain();
    return RECORDED_MUSIC_FILES[this.currentRecordedMusicIndex];
  }

  playMenuMusic(){
    return this.playRandomRecordedMusic('menu');
  }

  playRandomLevelMusic(){
    return this.playRandomRecordedMusic('level');
  }

  stopMusic(){
    this.musicPaused=true;
    this.currentRecordedMusicIndex=-1;
    this.musicTrack=null;
    if(this.musicElement){
      this.musicElement.pause();
      this.musicElement.removeAttribute('src');
      this.musicElement.load();
    }
    if(this.musicGain&&this.context){
      this.musicGain.gain.setTargetAtTime(0,this.context.currentTime,.04);
    }
  }

  pauseMusic(value=true){
    this.musicPaused=value;
    if(!value&&this.musicElement?.ended){
      this.playRandomRecordedMusic(this.musicMode);
      return;
    }
    if(!value)this.tryPlayRecordedMusic();
    this.updateMusicGain();
  }

  updateMusicGain(){
    if(!this.musicGain||!this.context)return;
    // Las pistas masterizadas tienen mucha más energía que los antiguos
    // osciladores. Este nivel deja espacio para motores, armas y explosiones.
    const volume=(this.musicPaused?.045:(this.musicMode==='menu'?.18:.22))*this.musicVolume;
    this.musicGain.gain.setTargetAtTime(volume,this.context.currentTime,.12);
  }

  nitroProfile(design={}){
    let profile={filterType:'bandpass',filter:1120,tone:178,wave:'sawtooth',noiseGain:.075,toneGain:.024,pulse:12,ignitionGain:.065};
    if(design.style==='plasma')profile={filterType:'bandpass',filter:1550,tone:330,wave:'sine',noiseGain:.07,toneGain:.025,pulse:7,ignitionGain:.065};
    if(design.style==='confetti')profile={filterType:'highpass',filter:2150,tone:540,wave:'triangle',noiseGain:.064,toneGain:.018,pulse:25,ignitionGain:.065};
    if(design.id==='hot_flames')profile={filterType:'lowpass',filter:690,tone:108,wave:'sawtooth',noiseGain:.09,toneGain:.032,pulse:10,ignitionGain:.065};
    return {
      filterType:AUDIO_FILTERS.has(design.soundFilterType)?design.soundFilterType:profile.filterType,
      filter:audioNumber(design.soundFilter,profile.filter,70,12000),
      tone:audioNumber(design.soundTone,profile.tone,30,2400),
      wave:AUDIO_WAVES.has(design.soundWave)?design.soundWave:profile.wave,
      noiseGain:audioNumber(design.soundNoiseGain,profile.noiseGain,0,.5),
      toneGain:audioNumber(design.soundToneGain,profile.toneGain,0,.5),
      pulse:audioNumber(design.soundPulse,profile.pulse,.1,100),
      ignitionGain:audioNumber(design.soundIgnitionGain,profile.ignitionGain,0,.5),
    };
  }

  nitroIgnition(design={}){
    if(
      design.soundMode==='mp3'
      &&design.soundUrl
      &&this.nitroSampleLoadedUrl===design.soundUrl
    )return;
    const profile=this.nitroProfile(design);
    if(profile.noiseGain>0)this.noise(.16,profile.noiseGain*1.35,profile.filter*1.28,profile.filterType);
    if(profile.ignitionGain>0)this.blip(profile.tone*1.7,.14,profile.wave,profile.ignitionGain);
    if(design.style==='confetti'&&profile.ignitionGain>0)this.blip(profile.tone*2.15,.09,'square',profile.ignitionGain*.54);
  }

  nitroRelease(design={}){
    if(
      design.soundMode==='mp3'
      &&design.soundUrl
      &&this.nitroSampleLoadedUrl===design.soundUrl
    )return;
    const profile=this.nitroProfile(design);
    if(profile.noiseGain>0)this.noise(.1,profile.noiseGain*.55,profile.filter*.78,profile.filterType);
  }

  stopEngineSampleSource(){
    if(!this.engineSampleSource)return;
    const source=this.engineSampleSource;
    this.engineSampleSource=null;
    this.engineSampleLoadedUrl='';
    try{source.stop();}
    catch{
      // La fuente puede haber terminado antes de cambiar de motor.
    }
    source.disconnect();
  }

  setEngineSampleUrl(value,settings={}){
    const url=String(value||'').trim();
    if(url===this.engineSampleTargetUrl)return;
    this.engineSampleTargetUrl=url;
    const request=++this.engineSampleRequest;
    this.engineSampleGain?.gain.setTargetAtTime(0,this.context.currentTime,.03);
    this.stopEngineSampleSource();
    if(!url)return;
    let pending=this.engineSampleBuffers.get(url);
    if(!pending){
      pending=fetch(url)
        .then((response)=>{
          if(!response.ok)throw new Error(`HTTP ${response.status}`);
          return response.arrayBuffer();
        })
        .then((buffer)=>this.context.decodeAudioData(buffer));
      this.engineSampleBuffers.set(url,pending);
    }
    pending.then((decodedBuffer)=>{
      if(request!==this.engineSampleRequest||url!==this.engineSampleTargetUrl)return;
      const buffer=createSeamlessAudioLoop(this.context,decodedBuffer,settings);
      const source=this.context.createBufferSource();
      source.buffer=buffer;
      source.loop=true;
      source.connect(this.engineSampleFilter);
      source.addEventListener('ended',()=>{
        if(this.engineSampleSource===source){
          this.engineSampleSource=null;
          this.engineSampleLoadedUrl='';
        }
        source.disconnect();
      },{once:true});
      this.engineSampleSource=source;
      this.engineSampleLoadedUrl=url;
      source.start();
    }).catch((error)=>{
      if(request!==this.engineSampleRequest)return;
      console.warn(`No se pudo cargar el loop de motor ${url}.`,error);
      this.engineSampleBuffers.delete(url);
    });
  }

  stopNitroSampleSource(){
    if(!this.nitroSampleSource)return;
    const source=this.nitroSampleSource;
    this.nitroSampleSource=null;
    this.nitroSampleLoadedUrl='';
    try{source.stop();}
    catch{
      // La fuente puede haber terminado antes de cambiar de nitro.
    }
    source.disconnect();
  }

  setNitroSampleUrl(value,settings={}){
    const url=String(value||'').trim();
    if(url===this.nitroSampleTargetUrl)return;
    this.nitroSampleTargetUrl=url;
    const request=++this.nitroSampleRequest;
    this.nitroSampleGain?.gain.setTargetAtTime(0,this.context.currentTime,.03);
    this.stopNitroSampleSource();
    if(!url)return;
    const record=this.prepareOneShotSample(url);
    record?.promise?.then((decodedBuffer)=>{
      if(
        !decodedBuffer
        ||request!==this.nitroSampleRequest
        ||url!==this.nitroSampleTargetUrl
      )return;
      const buffer=createSeamlessAudioLoop(this.context,decodedBuffer,settings);
      const source=this.context.createBufferSource();
      source.buffer=buffer;
      source.loop=true;
      source.connect(this.nitroSampleGain);
      source.addEventListener('ended',()=>{
        if(this.nitroSampleSource===source){
          this.nitroSampleSource=null;
          this.nitroSampleLoadedUrl='';
        }
        source.disconnect();
      },{once:true});
      this.nitroSampleSource=source;
      this.nitroSampleLoadedUrl=url;
      source.start();
    });
  }

  update(speed, boosting, active, skidAmount = 0, nitroEffect = null, engineSound = null) {
    if (!this.context || !this.engineOsc) return;
    const now=this.context.currentTime;
    const engine=engineSound||{};
    const nitro=nitroEffect||this.boostDesign||{};
    if(engineSound){
      this.setEngineSampleUrl(engine.mode==='mp3'?engine.assetUrl:'',engine);
    }
    this.setNitroSampleUrl(
      nitro.soundMode==='mp3'?nitro.soundUrl:'',
      nitro,
    );
    const nitroSampleReady=Boolean(
      this.nitroSampleSource
      &&this.nitroSampleLoadedUrl
      &&this.nitroSampleLoadedUrl===this.nitroSampleTargetUrl
    );
    const sampleReady=Boolean(
      this.engineSampleSource
      &&this.engineSampleLoadedUrl
      &&this.engineSampleLoadedUrl===this.engineSampleTargetUrl
    );
    const engineWave=AUDIO_WAVES.has(engine.wave)?engine.wave:'sawtooth';
    const baseTone=audioNumber(engine.baseTone,65,25,280);
    const speedPitch=audioNumber(engine.speedPitch,7,1,18);
    const boostPitch=audioNumber(engine.boostPitch,45,0,160);
    const pulse=audioNumber(engine.pulse,6,.1,30);
    const pulseAmount=.94+Math.sin(now*pulse)*.06;
    this.engineOsc.type=engineWave;
    this.engineOsc.frequency.setTargetAtTime((baseTone+Math.abs(speed)*speedPitch+(boosting?boostPitch:0))*pulseAmount,now,.05);
    this.engineFilter.type=AUDIO_FILTERS.has(engine.filterType)?engine.filterType:'lowpass';
    this.engineFilter.frequency.setTargetAtTime(audioNumber(engine.filter,430,70,12000)+Math.abs(speed)*12,now,.07);
    this.engineFilter.Q.setTargetAtTime(audioNumber(engine.resonance,1,0,18),now,.08);
    const engineVolume=audioNumber(engine.volume,.037,0,.18);
    this.engineGain.gain.setTargetAtTime(
      active&&!sampleReady
        ?engineVolume*.34+Math.min(Math.abs(speed)/800,engineVolume*.66)
        :0,
      now,
      .08,
    );
    this.engineNoiseFilter.type=this.engineFilter.type;
    this.engineNoiseFilter.frequency.setTargetAtTime(audioNumber(engine.filter,430,70,12000)*.82+Math.abs(speed)*10,now,.08);
    this.engineNoiseGain.gain.setTargetAtTime(
      active&&!sampleReady?audioNumber(engine.noiseGain,.005,0,.08):0,
      now,
      .1,
    );
    if(this.engineSampleGain&&this.engineSampleFilter){
      const idleRate=audioNumber(engine.sampleIdleRate,1,.5,1.5);
      const speedRate=audioNumber(engine.sampleSpeedRate,.04,0,.12);
      const boostRate=audioNumber(engine.sampleBoostRate,.35,0,1.2);
      const playbackRate=Math.max(
        .35,
        Math.min(3,idleRate+Math.abs(speed)*speedRate+(boosting?boostRate:0)),
      );
      this.engineSampleSource?.playbackRate.setTargetAtTime(playbackRate,now,.055);
      this.engineSampleFilter.frequency.setTargetAtTime(
        audioNumber(engine.sampleFilter,12000,500,16000),
        now,
        .08,
      );
      const sampleVolume=audioNumber(engine.sampleVolume,.28,.02,.8);
      const speedVolume=.72+Math.min(1,Math.abs(speed)/24)*.28;
      this.engineSampleGain.gain.setTargetAtTime(
        active&&sampleReady?sampleVolume*speedVolume:0,
        now,
        .08,
      );
    }
    const skid=active?Math.max(0,Math.min(1,skidAmount)):0;
    this.skidGain?.gain.setTargetAtTime(skid*.085,now,.035);
    this.skidFilter?.frequency.setTargetAtTime(760+Math.abs(speed)*30,now,.045);
    this.skidOsc?.frequency.setTargetAtTime(430+Math.abs(speed)*18,now,.04);
    this.skidOscGain?.gain.setTargetAtTime(skid*skid*.012,now,.035);

    const boostActive=Boolean(active&&boosting);
    if(boostActive&&!this.boostWasActive){
      this.boostDesign=nitroEffect||{};
      this.nitroIgnition(this.boostDesign);
    }else if(!boostActive&&this.boostWasActive){
      this.nitroRelease(this.boostDesign||{});
    }
    this.boostWasActive=boostActive;
    const profile=this.nitroProfile(nitro);
    const flutter=boostActive
      ? (nitroEffect?.style==='confetti' ? .78+Math.sin(now*profile.pulse)*.22 : .94+Math.sin(now*profile.pulse)*.06)
      : 0;
    this.boostFilter.type=profile.filterType;
    this.boostFilter.frequency.setTargetAtTime(profile.filter+Math.abs(speed)*18,now,.04);
    this.boostGain.gain.setTargetAtTime(
      boostActive&&!nitroSampleReady?profile.noiseGain*flutter:0,
      now,
      boostActive ? .045 : .12,
    );
    this.boostOsc.type=profile.wave;
    this.boostOsc.frequency.setTargetAtTime(profile.tone+Math.abs(speed)*2.5,now,.045);
    this.boostOscGain.gain.setTargetAtTime(
      boostActive&&!nitroSampleReady?profile.toneGain*flutter:0,
      now,
      boostActive ? .045 : .11,
    );
    if(this.nitroSampleGain){
      this.nitroSampleSource?.playbackRate.setTargetAtTime(
        audioNumber(nitro.soundSampleRate,1,.5,2),
        now,
        .045,
      );
      this.nitroSampleGain.gain.setTargetAtTime(
        boostActive&&nitroSampleReady
          ?audioNumber(nitro.soundSampleVolume,.5,.02,1)
          :0,
        now,
        boostActive?.045:.12,
      );
    }
    this.scheduleMusic();
  }

  updateSpatialVehicles(camera,localVehicle,vehicles=[]){
    if(!this.context||!this.effectsGain||!camera)return;
    const now=this.context.currentTime;
    const matrix=camera.matrixWorld?.elements;
    const position=matrix
      ?{x:matrix[12],y:matrix[13],z:matrix[14]}
      :camera.position;
    const forward=matrix
      ?{x:-matrix[8],y:-matrix[9],z:-matrix[10]}
      :{x:0,y:0,z:-1};
    const up=matrix
      ?{x:matrix[4],y:matrix[5],z:matrix[6]}
      :{x:0,y:1,z:0};
    const listener=this.context.listener;
    if(listener.positionX){
      setAudioParam(listener.positionX,position.x,now,.018);
      setAudioParam(listener.positionY,position.y,now,.018);
      setAudioParam(listener.positionZ,position.z,now,.018);
      setAudioParam(listener.forwardX,forward.x,now,.018);
      setAudioParam(listener.forwardY,forward.y,now,.018);
      setAudioParam(listener.forwardZ,forward.z,now,.018);
      setAudioParam(listener.upX,up.x,now,.018);
      setAudioParam(listener.upY,up.y,now,.018);
      setAudioParam(listener.upZ,up.z,now,.018);
    }else{
      listener.setPosition?.(position.x,position.y,position.z);
      listener.setOrientation?.(forward.x,forward.y,forward.z,up.x,up.y,up.z);
    }

    const origin=localVehicle?.car?.position||position;
    const selected=new Set(
      vehicles
        .filter((vehicle)=>vehicle&&vehicle!==localVehicle&&!vehicle.disabled&&vehicle.car?.visible!==false)
        .map((vehicle)=>({
          vehicle,
          distanceSquared:vehicle.car.position.distanceToSquared(origin),
        }))
        .filter((entry)=>entry.distanceSquared<30*30)
        .sort((a,b)=>a.distanceSquared-b.distanceSquared)
        .slice(0,this.maxSpatialVehicles)
        .map((entry)=>entry.vehicle),
    );
    this.spatialVehicleEmitters.forEach((emitter,vehicle)=>{
      if(selected.has(vehicle))return;
      emitter.dispose();
      this.spatialVehicleEmitters.delete(vehicle);
    });
    selected.forEach((vehicle)=>{
      let emitter=this.spatialVehicleEmitters.get(vehicle);
      if(!emitter){
        emitter=new SpatialVehicleEmitter(this,vehicle);
        this.spatialVehicleEmitters.set(vehicle,emitter);
      }
      emitter.update(vehicle);
    });
  }

  clearSpatialVehicles(){
    this.spatialVehicleEmitters.forEach((emitter)=>emitter.dispose());
    this.spatialVehicleEmitters.clear();
  }

  spatialDestination(position,lifetime=4){
    if(!this.context||!this.effectsGain||!position)return null;
    const panner=this.context.createPanner();
    panner.panningModel='HRTF';
    panner.distanceModel='inverse';
    panner.refDistance=2;
    panner.maxDistance=34;
    panner.rolloffFactor=1.15;
    const now=this.context.currentTime;
    setAudioParam(panner.positionX,Number(position.x)||0,now,.001);
    setAudioParam(panner.positionY,Number(position.y)||0,now,.001);
    setAudioParam(panner.positionZ,Number(position.z)||0,now,.001);
    if(!panner.positionX&&typeof panner.setPosition==='function'){
      panner.setPosition(Number(position.x)||0,Number(position.y)||0,Number(position.z)||0);
    }
    panner.connect(this.effectsGain);
    window.setTimeout(()=>{try{panner.disconnect();}catch{}},Math.max(.2,lifetime)*1000);
    return panner;
  }

  scheduleMusic(){
    if(!this.context||!this.musicTrack||!this.musicGain||!this.noiseBuffer)return;
    const horizon=this.context.currentTime+.18;
    const stepDuration=60/this.musicTrack.bpm/4;
    if(this.nextMusicTime<this.context.currentTime-.3)this.nextMusicTime=this.context.currentTime+.04;
    while(this.nextMusicTime<horizon){
      this.scheduleMusicStep(this.musicTrack,this.musicStep,this.nextMusicTime,stepDuration);
      this.musicStep=(this.musicStep+1)%16;
      this.nextMusicTime+=stepDuration;
    }
  }

  scheduleMusicStep(track,step,time,stepDuration){
    const lead=track.lead[step];
    if(lead!==null)this.musicTone(midiFrequency(track.root+24+lead),time,stepDuration*.82,track.wave,.045);
    const bass=track.bass[step];
    if(bass!==null)this.musicTone(midiFrequency(track.root+bass),time,stepDuration*.9,track.bassWave,.055);
    if(step%4===0){
      const chordRoot=track.root+12+track.chords[step/4];
      const third=track.minor?3:4;
      this.musicTone(midiFrequency(chordRoot),time,stepDuration*3.65,'triangle',.018);
      this.musicTone(midiFrequency(chordRoot+third),time,stepDuration*3.65,'triangle',.014);
      this.musicTone(midiFrequency(chordRoot+7),time,stepDuration*3.65,'triangle',.013);
    }
    if(track.kick[step]==='x')this.musicKick(time);
    if(track.snare[step]==='x')this.musicNoise(time,.11,.032,1250,'bandpass');
    if(track.hats[step]==='x')this.musicNoise(time,.035,.012,5200,'highpass');
  }

  musicTone(frequency,time,duration,type='triangle',volume=.04){
    const oscillator=this.context.createOscillator();
    const gain=this.context.createGain();
    oscillator.type=type;oscillator.frequency.setValueAtTime(frequency,time);
    gain.gain.setValueAtTime(.001,time);
    gain.gain.exponentialRampToValueAtTime(volume,time+.008);
    gain.gain.exponentialRampToValueAtTime(.001,time+duration);
    oscillator.connect(gain);gain.connect(this.musicGain);oscillator.start(time);oscillator.stop(time+duration+.02);
  }

  musicKick(time){
    const oscillator=this.context.createOscillator();
    const gain=this.context.createGain();
    oscillator.type='sine';oscillator.frequency.setValueAtTime(118,time);oscillator.frequency.exponentialRampToValueAtTime(42,time+.13);
    gain.gain.setValueAtTime(.09,time);gain.gain.exponentialRampToValueAtTime(.001,time+.15);
    oscillator.connect(gain);gain.connect(this.musicGain);oscillator.start(time);oscillator.stop(time+.16);
  }

  musicNoise(time,duration,volume,frequency,type){
    const source=this.context.createBufferSource();source.buffer=this.noiseBuffer;
    const filter=this.context.createBiquadFilter();filter.type=type;filter.frequency.setValueAtTime(frequency,time);
    const gain=this.context.createGain();gain.gain.setValueAtTime(volume,time);gain.gain.exponentialRampToValueAtTime(.001,time+duration);
    source.connect(filter);filter.connect(gain);gain.connect(this.musicGain);source.start(time);source.stop(time+duration);
  }

  noise(duration=.12,volume=.05,frequency=900,type='bandpass',destination=this.effectsGain){
    if(!this.context||this.muted||!this.noiseBuffer)return;
    const now=this.context.currentTime;
    const source=this.context.createBufferSource();source.buffer=this.noiseBuffer;
    const filter=this.context.createBiquadFilter();filter.type=type;filter.frequency.setValueAtTime(frequency,now);filter.frequency.exponentialRampToValueAtTime(Math.max(70,frequency*.42),now+duration);
    const gain=this.context.createGain();gain.gain.setValueAtTime(Math.max(.001,volume),now);gain.gain.exponentialRampToValueAtTime(.001,now+duration);
    source.connect(filter);filter.connect(gain);gain.connect(destination||this.effectsGain);source.start(now);source.stop(now+duration);
  }

  playProfile(design={},prefix='',volume=1,destination=this.effectsGain){
    if(!this.context||this.muted)return;
    const strength=Math.max(.12,Math.min(1,volume));
    const wave=AUDIO_WAVES.has(design[`${prefix}Wave`])?design[`${prefix}Wave`]:'square';
    const tone=audioNumber(design[`${prefix}Tone`],320,30,4800);
    const duration=audioNumber(design[`${prefix}Duration`],.1,.03,2.5);
    const filter=audioNumber(design[`${prefix}Filter`],1800,70,12000);
    const noiseGain=audioNumber(design[`${prefix}NoiseGain`],.05,0,.5);
    const toneGain=audioNumber(design[`${prefix}ToneGain`],.07,0,.5);
    const filterType=filter>2200?'highpass':'bandpass';
    if(noiseGain>0)this.noise(duration,noiseGain*strength,filter,filterType,destination);
    if(toneGain>0){
      const now=this.context.currentTime;
      const oscillator=this.context.createOscillator();
      const toneFilter=this.context.createBiquadFilter();
      const gain=this.context.createGain();
      oscillator.type=wave;
      oscillator.frequency.setValueAtTime(tone,now);
      oscillator.frequency.exponentialRampToValueAtTime(Math.max(28,tone*.52),now+duration);
      toneFilter.type=filterType;
      toneFilter.frequency.setValueAtTime(filter,now);
      gain.gain.setValueAtTime(Math.max(.001,toneGain*strength),now);
      gain.gain.exponentialRampToValueAtTime(.001,now+duration);
      oscillator.connect(toneFilter);
      toneFilter.connect(gain);
      gain.connect(destination||this.effectsGain);
      oscillator.start(now);
      oscillator.stop(now+duration+.02);
    }
  }

  prepareOneShotSample(url){
    const normalizedUrl=String(url||'').trim();
    if(!normalizedUrl||!this.context)return null;
    let record=this.oneShotSampleBuffers.get(normalizedUrl);
    if(record)return record;
    record={buffer:null,failed:false,promise:null};
    record.promise=fetch(normalizedUrl)
      .then((response)=>{
        if(!response.ok)throw new Error(`HTTP ${response.status}`);
        return response.arrayBuffer();
      })
      .then((buffer)=>this.context.decodeAudioData(buffer))
      .then((buffer)=>{
        record.buffer=buffer;
        return buffer;
      })
      .catch((error)=>{
        record.failed=true;
        console.warn(`No se pudo cargar el audio ${normalizedUrl}.`,error);
        return null;
      });
    this.oneShotSampleBuffers.set(normalizedUrl,record);
    return record;
  }

  sampleSettings(design={},prefix='sound'){
    const named=prefix!=='sound';
    return {
      mode:design[named?`${prefix}SoundMode`:'soundMode'],
      url:design[named?`${prefix}SoundUrl`:'soundUrl'],
      volume:design[`${prefix}SampleVolume`],
      rate:design[`${prefix}SampleRate`],
    };
  }

  prepareDesignSample(design={},prefix='sound'){
    const settings=this.sampleSettings(design,prefix);
    if(settings.mode!=='mp3'||!settings.url)return null;
    return this.prepareOneShotSample(settings.url);
  }

  prepareCannonSample(design={}){
    return this.prepareDesignSample(design,'sound');
  }

  prepareNitroSample(design={}){
    if(design.soundMode!=='mp3'||!design.soundUrl)return null;
    return this.prepareOneShotSample(design.soundUrl);
  }

  playDesignSample(design={},prefix='sound',volume=1,destination=this.effectsGain){
    const settings=this.sampleSettings(design,prefix);
    if(settings.mode!=='mp3'||!settings.url)return false;
    return this.playOneShotSample(
      settings.url,
      audioNumber(settings.volume,.5,.02,1)*Math.max(.12,Math.min(1,volume)),
      settings.rate,
      destination,
    );
  }

  playOneShotSample(url,volume=1,rate=1,destination=this.effectsGain){
    if(!this.context||this.muted)return false;
    const record=this.prepareOneShotSample(url);
    if(!record?.buffer)return false;
    const source=this.context.createBufferSource();
    const gain=this.context.createGain();
    source.buffer=record.buffer;
    source.playbackRate.value=audioNumber(rate,1,.5,2);
    gain.gain.value=audioNumber(volume,.5,.001,1);
    source.connect(gain);
    gain.connect(destination||this.effectsGain);
    source.addEventListener('ended',()=>{
      source.disconnect();
      gain.disconnect();
    },{once:true});
    source.start();
    return true;
  }

  cannonFire(design={},volume=1,destination=this.effectsGain){
    if(this.playDesignSample(design,'sound',volume,destination))return;
    this.playProfile(design,'sound',volume,destination);
  }

  projectileTravel(design={},volume=1,destination=this.effectsGain){
    if(this.playDesignSample(design,'travel',volume,destination))return;
    this.playProfile(design,'travel',volume,destination);
  }

  projectileImpact(designOrVolume={},volume=1,destination=this.effectsGain){
    if(!this.context||this.muted)return;
    if(typeof designOrVolume==='object'){
      if(this.playDesignSample(designOrVolume,'impact',volume,destination))return;
      this.playProfile(designOrVolume,'impact',volume,destination);
      return;
    }
    volume=designOrVolume;
    const strength=Math.max(.15,Math.min(1,volume));
    this.noise(.095,.075*strength,1750,'highpass',destination);
    this.blip(310+Math.random()*75,.075,'square',.085*strength,destination);
  }

  tombstone(design={},volume=1,destination=this.effectsGain){
    if(this.playDesignSample(design,'sound',volume,destination))return;
    this.playProfile(design,'sound',volume,destination);
  }

  explosion(design={},volume=1,destination=this.effectsGain){
    if(!this.context||this.muted)return;
    if(this.playDesignSample(design,'sound',volume,destination))return;
    const strength=Math.max(.18,Math.min(1,volume));
    const style=design.style||'burst';
    const now=this.context.currentTime;
    const defaults=style==='plasma'
      ?{wave:'sine',pitch:235,duration:.44,filter:720,filterType:'lowpass',noiseGain:.16,toneGain:.18,accentGain:.055}
      :style==='firework'
        ?{wave:'square',pitch:112,duration:.44,filter:1450,filterType:'highpass',noiseGain:.16,toneGain:.18,accentGain:.07}
        :style==='confetti'
          ?{wave:'sawtooth',pitch:155,duration:.44,filter:520,filterType:'lowpass',noiseGain:.1,toneGain:.18,accentGain:.045}
          :{wave:'sawtooth',pitch:112,duration:.44,filter:520,filterType:'lowpass',noiseGain:.16,toneGain:.18,accentGain:0};
    const wave=AUDIO_WAVES.has(design.soundWave)?design.soundWave:defaults.wave;
    const filterType=AUDIO_FILTERS.has(design.soundFilterType)?design.soundFilterType:defaults.filterType;
    const startFrequency=audioNumber(design.soundPitch,defaults.pitch,30,2400);
    const duration=audioNumber(design.soundDuration,defaults.duration,.08,2.5);
    const filter=audioNumber(design.soundFilter,defaults.filter,70,12000);
    const noiseGain=audioNumber(design.soundNoiseGain,defaults.noiseGain,0,.6);
    const toneGain=audioNumber(design.soundToneGain,defaults.toneGain,0,.6);
    const accentGain=audioNumber(design.soundAccentGain,defaults.accentGain,0,.4);
    const osc=this.context.createOscillator();
    const gain=this.context.createGain();
    osc.type=wave;
    osc.frequency.setValueAtTime(startFrequency,now);
    osc.frequency.exponentialRampToValueAtTime(Math.max(28,startFrequency*.28),now+duration);
    gain.gain.setValueAtTime(Math.max(.001,toneGain*strength),now);
    gain.gain.exponentialRampToValueAtTime(.001,now+duration);
    osc.connect(gain);gain.connect(destination||this.effectsGain);osc.start(now);osc.stop(now+duration+.01);
    if(noiseGain>0)this.noise(duration,noiseGain*strength,filter,filterType,destination);
    if(accentGain>0){
      const accent=this.context.createOscillator();
      const accentVolume=this.context.createGain();
      const accentDuration=Math.min(.24,duration);
      accent.type=style==='firework'?'square':'triangle';
      accent.frequency.setValueAtTime(startFrequency*3.4,now+.015);
      accent.frequency.exponentialRampToValueAtTime(
        Math.max(45,startFrequency*1.4),
        now+Math.min(.22,duration),
      );
      accentVolume.gain.setValueAtTime(.001,now);
      accentVolume.gain.linearRampToValueAtTime(
        Math.max(.001,accentGain*strength),
        now+.018,
      );
      accentVolume.gain.exponentialRampToValueAtTime(.001,now+accentDuration);
      accent.connect(accentVolume);
      accentVolume.connect(destination||this.effectsGain);
      accent.start(now);
      accent.stop(now+accentDuration+.02);
    }
  }

  blip(frequency=420,duration=.08,type='square',volume=.08,destination=this.effectsGain){
    if(!this.context||this.muted)return;
    const osc=this.context.createOscillator();const gain=this.context.createGain();osc.type=type;osc.frequency.setValueAtTime(frequency,this.context.currentTime);osc.frequency.exponentialRampToValueAtTime(Math.max(40,frequency*.55),this.context.currentTime+duration);gain.gain.setValueAtTime(volume,this.context.currentTime);gain.gain.exponentialRampToValueAtTime(.001,this.context.currentTime+duration);osc.connect(gain);gain.connect(destination||this.effectsGain);osc.start();osc.stop(this.context.currentTime+duration);
  }

  cannonFireAt(design={},position,volume=1){
    const destination=this.spatialDestination(position,5);
    this.cannonFire(design,volume,destination||this.effectsGain);
  }

  projectileTravelAt(design={},position,volume=1){
    const destination=this.spatialDestination(position,5);
    this.projectileTravel(design,volume,destination||this.effectsGain);
  }

  projectileImpactAt(design={},position,volume=1){
    const destination=this.spatialDestination(position,5);
    this.projectileImpact(design,volume,destination||this.effectsGain);
  }

  explosionAt(design={},position,volume=1){
    const destination=this.spatialDestination(position,6);
    this.explosion(design,volume,destination||this.effectsGain);
  }

  tombstoneAt(design={},position,volume=1){
    const destination=this.spatialDestination(position,5);
    this.tombstone(design,volume,destination||this.effectsGain);
  }

  uiBlip(frequency=420,duration=.08,type='square',volume=.08){
    this.blip(
      frequency,
      duration,
      type,
      Math.min(.22,volume*UI_SOUND_VOLUME_MULTIPLIER),
    );
  }
}
